module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "ch5"
    }
  }), _c('em', [_vm._v("Dry Time")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Killed, the sand")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("didn’t give. All waves")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("went dead: your border")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("crossed itself.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I couldn’t tell or tear")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("us apart. In the absence")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("of hourglasses")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("meanwhiles")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("piled up, swells of the")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("dispellable. Even the diamond")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("shed no oil, not a drop")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("to delight the drilltip.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "common.jpg",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Partners having come")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("unwelded (blasted by nuclear")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("family life) we went")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("a long")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("way back,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("as far as Abacus (empire of")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the rook and stork). We roused")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("some dowsers")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("from a timeless doze, we had them")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("scatter Onan’s")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("nanoseconds")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("everywhere: in waves and particles, the clearest")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("solitudes could be")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("broadcast. At last")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you kissed me, I")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("could die again, and one")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("good lick")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("of quicksand")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("took . . .")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18385f1f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter05.vue
// module id = 96
// module chunks = 0